import React from 'react'
import { notification } from 'antd'

import { MAX_ASSIGNED_DEFINITION_TASK_LIMIT_REACHED } from '../../constants/error-types'

import { MaxAssignedDefinitionTaskLimitReachedErrorDescription } from './error-descriptions'

const showErrorNotification = ({ message, description, error }) => {
  const { type, data } = error?.graphQLErrors?.[0]?.extensions?.exception || {}

  let formattedDescription = description || error?.message
  if (type === MAX_ASSIGNED_DEFINITION_TASK_LIMIT_REACHED) {
    formattedDescription = (
      <MaxAssignedDefinitionTaskLimitReachedErrorDescription
        taskTypes={data.taskTypes}
        userId={data.userId}
      />
    )
  }

  return notification.open({
    type: 'error',
    placement: 'bottomRight',
    duration: 0,
    message,
    description: formattedDescription,
  })
}

export default showErrorNotification
